import React from 'react';
import styled from 'styled-components';

const HeroContainer = styled.div`
  margin-bottom: 60px;
  text-align: center;
`;

const CategoryBadge = styled.span`
  background: #f1f5f9;
  color: var(--color-primary-blue);
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 24px;
`;

const Title = styled.h1`
  font-family: var(--font-serif);
  font-size: clamp(2.5rem, 5vw, 4rem);
  color: var(--color-text);
  margin-bottom: 24px;
  line-height: 1.2;
`;

const Description = styled.p`
  font-family: var(--font-sans);
  font-size: 1.2rem;
  color: var(--color-text-light);
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto 40px;
`;

const EventHero = ({
  category,
  title,
  description,
  children
}) => (
  <HeroContainer>
    {category && <CategoryBadge>{category}</CategoryBadge>}
    <Title>{title}</Title>
    {description && <Description>{description}</Description>}
    {children}
  </HeroContainer>
);

export default EventHero;